import { render } from "./SalarySlipPage.vue?vue&type=template&id=f783021c"
import script from "./SalarySlipPage.vue?vue&type=script&lang=js"
export * from "./SalarySlipPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__